import { useDesign } from "../../../../context/contextDesign";
import { useAwsConfig } from "../../../../context/Dashboard/aws/contextConfig";
import { useThemeMode } from "../../../../context/contextTheme";
import hexToRGBA from "../../../../utils/hexToRGBA";

const AwsConfigTable = () => {
  const { zoom } = useDesign();
  const { theme } = useThemeMode();
  const { cAwsConfigAll: rawData } = useAwsConfig();

  const summary = rawData?.last_run?.summary || {};
  const hasSummary = Object.keys(summary).length > 0;

  // Helper for Severity Badge Styling
  const getSeverityStyle = (item) => {
    if (item.flagged_items > 0) return { color: "#dc3545", bg: hexToRGBA("#dc3545", 0.1), label: "Critical" };
    if (item.rules_count > 0) return { color: "#ffc107", bg: hexToRGBA("#ffc107", 0.1), label: "Warning" };
    return { color: "#198754", bg: hexToRGBA("#198754", 0.1), label: "Good" };
  };

  return (
    <div className="d-flex flex-column h-100 overflow-hidden" style={{ zoom }}>
      {!hasSummary ? (
        <div className="flex-grow-1 d-flex flex-column justify-content-center align-items-center opacity-50">
          <i className="bi bi-shield-exclamation display-1 mb-3"></i>
          <h4 className="fw-bold">AWS Misconfiguration Scan not yet started</h4>
        </div>
      ) : (
        <div className="d-flex flex-column h-100 p-4">

          {/* HEADER SECTION */}
          <div className="flex-shrink-0 mb-4 border-bottom pb-3">
            <h5 className="fw-bold mb-1" style={{ color: theme.textColor }}>AWS Misconfiguration</h5>
            <p className="text-muted small mb-0">High-level overview of findings across all cloud instances.</p>
          </div>

          {/* SCROLLABLE GRID OF ALL INSTANCES */}
          <div className="flex-grow-1 overflow-y-auto custom-scrollbar pe-2">
            <div className="row g-3">
              {Object.entries(summary).map(([service, item]) => {
                const status = getSeverityStyle(item);
                return (
                  <div className="col-12 col-md-6 col-xl-3" key={service}>
                    <div
                      className="card border-0 shadow-sm p-3 rounded-4 transition-all h-100 native-card-hover"
                      style={{ background: theme.background }}
                    >
                      <div className="d-flex justify-content-between align-items-start mb-3">
                        <div className="d-flex flex-column">
                          <span className="text-capitalize fw-bold" style={{ fontSize: '0.9rem' }}>{service}</span>
                          <span className="text-muted" style={{ fontSize: '0.65rem' }}>Cloud Service</span>
                        </div>
                        <span
                          className="badge rounded-pill fw-bolder"
                          style={{
                            backgroundColor: status.bg,
                            color: status.color,
                            fontSize: '0.6rem',
                            letterSpacing: '0.5px',
                            textTransform: 'uppercase'
                          }}
                        >
                          {status.label}
                        </span>
                      </div>

                      <div className="d-flex justify-content-between align-items-center bg-light rounded-3 p-2">
                        <div className="text-center flex-fill border-end">
                          <div className="text-muted" style={{ fontSize: '0.6rem' }}>Resources</div>
                          <div className="fw-bold small">{item.resources_count}</div>
                        </div>
                        <div className="text-center flex-fill border-end">
                          <div className="text-muted" style={{ fontSize: '0.6rem' }}>Findings</div>
                          <div className="fw-bold small text-danger">{item.flagged_items}</div>
                        </div>
                        <div className="text-center flex-fill">
                          <div className="text-muted" style={{ fontSize: '0.6rem' }}>Checks</div>
                          <div className="fw-bold small">{item.checked_items}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}

      <style>{`
        .native-card-hover {
          transition: transform 0.2s ease, box-shadow 0.2s ease;
          border: 1px solid transparent !important;
        }
        .native-card-hover:hover {
          transform: translateY(-3px);
          box-shadow: 0 8px 15px ${hexToRGBA("#344266", 0.1)} !important;
          border: 1px solid ${hexToRGBA("#344266", 0.1)} !important;
        }
        .custom-scrollbar::-webkit-scrollbar { width: 6px; }
        .custom-scrollbar::-webkit-scrollbar-thumb { 
          background: rgba(52, 66, 102, 0.1); 
          border-radius: 10px; 
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: transparent;
        }
      `}</style>
    </div>
  );
};

export default AwsConfigTable;